export const scrollingHeader = () => {
  let lastScrollTop = 0;
  let mobileMenuOpen = false;

  const menuToggle = document.querySelector(
    ".mega-menu-wrap .mega-menu-toggle"
  );

  if (menuToggle) {
    window.addEventListener(
      "scroll",
      function () {
        const currentScroll = window.scrollY || window.pageYOffset;
        const headerEl = document.querySelector(".header-mobile");

        if (menuToggle.classList.contains("mega-menu-open")) {
          mobileMenuOpen = true;
        } else {
          mobileMenuOpen = false;
        }

        if (currentScroll > lastScrollTop && !mobileMenuOpen) {
          // Scrolling down
          headerEl.style.transition = "transform 0.3s";
          headerEl.style.transform = "translateY(-100%)";
        } else {
          // Scrolling up
          headerEl.style.transition = "transform 0.3s";
          headerEl.style.transform = "translateY(0)";
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      },
      false
    );
  }

  // Add crolled class to header
  const headerEl = document.querySelector(".header-menu--desktop");
  if (headerEl) {
    if (window.scrollY > 100) {
      headerEl.classList.add("scrolled");
    } else {
      headerEl.classList.remove("scrolled");
    }
    window.addEventListener("scroll", function () {
      if (window.scrollY > 100) {
        headerEl.classList.add("scrolled");
      } else {
        headerEl.classList.remove("scrolled");
      }
    });
  }
};
